"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNSColorIconLink = exports.parseSnsLinkItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var SnsColorIcons_1 = require("../../DataDisplay/SnsColorIcons");
/** SnsLinkItem から url と label を抽出するヘルパー */
var parseSnsLinkItem = function (item) {
    return typeof item === 'string' ? { url: item } : item;
};
exports.parseSnsLinkItem = parseSnsLinkItem;
var SNS_COLOR_ICON_MAP = {
    instagram: SnsColorIcons_1.InstagramIcon,
    x: SnsColorIcons_1.XIcon,
    tiktok: SnsColorIcons_1.TiktokIcon,
    youtube: SnsColorIcons_1.YouTubeIcon,
};
// SNSの規約によってはaltに表示する文字列にも言及があるため、それぞれのSNSの規約に従って定義する
var SNS_ALT_MAP = {
    instagram: 'Instagram',
    x: 'X',
    tiktok: 'TikTok',
    youtube: 'YouTube',
};
var SNSColorIconLink = function (_a) {
    var _b;
    var url = _a.url, label = _a.label, labelColor = _a.labelColor, snsKey = _a.snsKey, _c = _a.ml, ml = _c === void 0 ? 0 : _c, _d = _a.width, width = _d === void 0 ? 32 : _d, _e = _a.height, height = _e === void 0 ? 32 : _e;
    var IconComponent = SNS_COLOR_ICON_MAP[snsKey];
    if (!IconComponent)
        return null;
    return ((0, jsx_runtime_1.jsxs)(material_1.Button, { component: "a", href: url, target: "_blank", rel: "noreferrer noopener", disableRipple: true, disableElevation: true, sx: {
            all: 'unset',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            ml: ml,
        }, children: [(0, jsx_runtime_1.jsx)(IconComponent, { alt: (_b = SNS_ALT_MAP[snsKey]) !== null && _b !== void 0 ? _b : '', size: { width: width, height: height }, sx: {
                    width: width,
                    height: height,
                } }), label && ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                    color: labelColor !== null && labelColor !== void 0 ? labelColor : 'inherit',
                    fontSize: '18px',
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    height: height, // アイコンと同じ高さに揃える
                }, children: label }))] }));
};
exports.SNSColorIconLink = SNSColorIconLink;
